import {
    ListenerMiddleware,
    registerPredicateEffect,
} from 'store/listenerMiddleware';
import { buildEstimatedTradeCostWidgetComponentSlice } from 'widgets/estimatedTradeCost/widget/store/componentSlice';
import { selectEstimatedTradeCostWidgetsState } from 'widgets/estimatedTradeCost/widget/store/selectors';
import { buildClearComponentStateOnSelectedOrderChangedEffect } from 'widgets/estimatedTradeCost/widget/store/effects-shared';

const {
    actions,
    selectors: { selectComponentState },
} = buildEstimatedTradeCostWidgetComponentSlice();

const clearComponentStateOnSelectedOrderChangedEffect =
    buildClearComponentStateOnSelectedOrderChangedEffect(
        'estimatedTradeCostWidget',
        selectEstimatedTradeCostWidgetsState,
        selectComponentState,
        actions.createUpdateComponentAction
    );

export function registerEstimatedTradeCostEffects(
    middleware: ListenerMiddleware
) {
    registerPredicateEffect(
        middleware,
        clearComponentStateOnSelectedOrderChangedEffect
    );
}
